import {Empty, Skeleton, Tooltip} from "antd";
import ActionsMenu from "../action-buttons/ActionsMenu";
import {
  ArrowRightOutlined,
  FileTextOutlined,
  SafetyCertificateOutlined
} from "@ant-design/icons";
import "./style.less"
import {PublicInfoListProps} from "./types";
import React from "react";
import {useAuth} from "../../context/authContext";
import {useNavigate} from "react-router-dom";


const PublicInfoList = (props: PublicInfoListProps) => {
  const {publicInfoItemsList, confirmDeletePublicInfoItem, editButtonHandler, isLoading} = props.publicInfoController
  const {canManageContent} = useAuth()
  const navigate = useNavigate()

  const openPublicInfoItemPage = (id: string | undefined) => {
    if (id) {
      navigate(`/public-info/${id}`)
    }
  }

  if (isLoading && !publicInfoItemsList.length) {
    return <section className="public-information-section">
      <div className="public-information-intro">
        <Skeleton active paragraph={{rows: 2}} title={{width: 240}}/>
      </div>
      <div className="public-information-grid">
        {Array.from({length: 8}).map((_, index) => <div className="public-information-skeleton" key={index}>
          <Skeleton active paragraph={{rows: 2}} title={{width: "78%"}}/>
        </div>)}
      </div>
    </section>
  }

  return (
    <section className="public-information-section">
      <div className="public-information-intro">
        <div className="public-information-intro__icon"><SafetyCertificateOutlined/></div>
        <div>
          <div className="public-information-intro__eyebrow">Документи закладу</div>
          <h1 className="public-information-intro__title">Відкрита та важлива інформація</h1>
          <p className="public-information-intro__description">
            Офіційні документи, звіти та матеріали лікарні зібрані в одному місці.
          </p>
        </div>
      </div>

      {publicInfoItemsList.length ? <div className={`public-information-grid ${isLoading ? "public-information-grid--updating" : ""}`}>
        {publicInfoItemsList.map((item) => <article className="public-information-card" key={item.$id}>
          <button className="public-information-card__link" type="button"
                  onClick={() => openPublicInfoItemPage(item.$id)}>
            <span className="public-information-card__icon"><FileTextOutlined/></span>
            <span className="public-information-card__label">Публічний документ</span>
            <Tooltip title={item.title}>
              <span className="public-information-card__title">{item.title}</span>
            </Tooltip>
            <span className="public-information-card__more">Переглянути <ArrowRightOutlined/></span>
          </button>

          {canManageContent && <div className="public-information-card__admin">
            <ActionsMenu
              label="Дії з публічним документом"
              onEdit={() => editButtonHandler(item)}
              onDelete={() => confirmDeletePublicInfoItem(item.$id || "")}
            />
          </div>}
        </article>)}
      </div> : <div className="public-information-empty">
        <Empty description="Публічних документів поки немає"/>
      </div>}
    </section>
  )
}


export default PublicInfoList
